import {
    getDefaultSignupDateRangeIso,
    formatSignupDateRangeDisplay,
} from "@/utils/defaultSignupDateRange";

const defaultRange = getDefaultSignupDateRangeIso();

export const namespaced = true;

export const state = {
    insurance_status: "all",
    page_number: 1,
    date_range: defaultRange,
    display_daterange: formatSignupDateRangeDisplay(defaultRange),
    from_date_range: [],
    display_from_daterange:"",
    product: "",
};
export const getters = {
    getFilters: (state) => {
        return state;
    },
};